import type { RouteLocationRaw } from 'vue-router'
import { listingPagePath, type ListingKind } from '@/composables/listing/use-listing-preview'

export function responseListingLocation(kind: ListingKind, id: string, response: string, returnTo: string): RouteLocationRaw {
  return { path: listingPagePath(kind, id), query: { response, returnTo } }
}

/** Only known response and chat routes are accepted, never arbitrary redirect URLs. */
export function responseReturnPath(value: unknown): string | null {
  if (typeof value !== 'string') return null
  if (/^\/chats\?id=[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/.test(value)) return value
  const path = value.split('?')[0]
  return /^\/applicant\/(responses|interviews|colloquies|archive)$/.test(path!)
    || /^\/company\/[\da-f-]{36}\/vacancies\/[\da-f-]{36}\/(responses|interviews|colloquies|archive)$/.test(path!)
    ? value : null
}
